export default {
	module: 'partners',
	actions: {
		list: true,
		dynamicPaths: [
			{
				paths: {
					'/partners/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			}

		]
	}
}
